import { render, staticRenderFns } from "./WarningModal2.vue?vue&type=template&id=e04ae16a"
import script from "./WarningModal2.vue?vue&type=script&lang=js"
export * from "./WarningModal2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports